import React from 'react';

export default class Signature extends React.Component {
  constructor(props) {
    super(props);

    // {
    //   id: "",
    //   coords: [],
    //   pdf_coords: [],
    //   date: [],
    //   page: ""
    // };
  }

  render() {
    let date = this.props.signature.date;
    let pdf_date_coords = this.props.signature.pdf_date_coords;

    let dateCoords;

    if (date != null) {
      dateCoords = (
        <div>
          <label>date coords</label>
          <br />
          <input type="text" value={date} readOnly={true} />
          <br />
          <label>date pdf coords</label>
          <br />
          <input type="text" value={pdf_date_coords} readOnly={true} />
        </div>
      );
    } else {
      dateCoords = (
        <a
          href="#"
          onClick={(e) => {
            let signature = Object.assign({}, this.props.signature);
            signature['date'] = [0, 0, 50, 20];
            signature['pdf_date_coords'] = [0, 0, 50, 20];
            this.props.onChange(signature, this.props.index);
            e.preventDefault();
          }}
        >
          + date coords{' '}
        </a>
      );
    }

    return (
      <div>
        <label>signature coords</label>
        <br />
        <input
          type="text"
          value={this.props.signature.coords}
          readOnly={true}
        />
        <br />
        <label>signature pdf coords</label>
        <br />
        <input
          type="text"
          value={this.props.signature.pdf_coords}
          readOnly={true}
        />
        <br />
        {dateCoords}
      </div>
    );
  }
}
